import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const store_data = JSON.parse(store());
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const InitialData = {
        tax_name: "",
        charge_type: "",
        charge_value: "",
        tax_type: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/taxes/fetchSingle", {...filter, user: store_data});
        const TaxData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: TaxData["id"],
                tax_name: TaxData["tax_name"],
                charge_type: TaxData["charge_type"],
                charge_value: TaxData["charge_value"],
                tax_type: TaxData["tax_type"],
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("FINANCE", "Taxes", "CREATE");
                const editAllowed = await hasPermission("FINANCE", "Taxes", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])


    const validate = () => {
        let errors = [];
        if (!FormData.tax_name) errors.push('Tax Name is required.');
        if (!FormData.charge_type) errors.push('Charge Type is required.');
        if (!FormData.charge_value) errors.push('Charge Value is required.');
        else if (isNaN(FormData.charge_value)) errors.push('Charge Value must be a number.');
        if (!FormData.tax_type) errors.push('Tax Type is required.');
        setError(errors);
        return errors.length === 0;
    };

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        
        if (!validate()) {
            toast.error('Please fix validation errors.');
            return;
        }
        setIsBTNClicked(true);
        const payload = { org_id: store_data?.org_id, ...FormData };
        const response = await postAPI(is_edit ? "/taxes/update" : "/taxes/create", {...payload, user: store_data});
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('New Tax Added Successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {Loading ? <Loader /> :
                (!isAdmin() && !canCreate && !canEdit) ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="tax_name" Type="text" Label="Tax Name" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <SelectBoxHandler Label="Charge Type" Options={[{"label": "Percentage", "value": "PERCENTAGE"}, {"label": "Amount", "value": "AMOUNT"}]} Name="charge_type" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="charge_value" Type="text" Label="Charge Value" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <SelectBoxHandler Label="Tax Type" Options={[{"label": "Inclusive", "value": "INCLUSIVE"}, {"label": "Exclusive", "value": "EXCLUSIVE"}]} Name="tax_type" setFormData={setFormData} form_data={FormData} MultiSelection={false} />
                        </div>
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer  position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
